module.exports = __webpack_public_path__ + "static/img/xia.0dd5cc56.png";